
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 28 31"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.962 10.77h1.906a4.632 4.632 0 014.632 4.632v9.926a4.632 4.632 0 01-4.632 4.633H5.632A4.632 4.632 0 011 25.328v-9.926a4.632 4.632 0 014.632-4.632h4.39l3.128-4.45","stroke":"currentColor","stroke-width":"1.324","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M5.302 20.415v5.243M4.64 15.048h8.603M9.934 20.415v5.243M14.566 20.415v5.243M19.199 20.415v5.243","stroke":"currentColor","stroke-width":"1.324","stroke-linecap":"round"}}),_c('path',{attrs:{"d":"M12.89 7.941a7.28 7.28 0 1114.559 0 7.28 7.28 0 01-14.559 0z","fill":"#5EC7F2"}}),_c('path',{attrs:{"d":"M16.98 6.755c.102-.19.247-.337.437-.444.194-.112.424-.168.691-.168.32 0 .61.085.867.255.257.165.458.408.604.728.15.316.225.69.225 1.121 0 .432-.075.808-.225 1.129a1.7 1.7 0 01-.604.727 1.57 1.57 0 01-.867.248c-.267 0-.497-.053-.691-.16a1.148 1.148 0 01-.437-.452v2.526h-1.616v-6.07h1.616v.56zm1.186 1.492c0-.218-.055-.388-.167-.51a.557.557 0 00-.43-.181.558.558 0 00-.429.182c-.111.121-.167.29-.167.51 0 .218.056.387.167.509a.558.558 0 00.43.182c.174 0 .317-.06.43-.182.11-.122.166-.291.166-.51zm6.914-3.1V10.3h-1.616V8.29h-1.536v2.01h-1.616V5.146h1.616v1.856h1.536V5.146h1.616z","fill":"#fff"}}),_c('path',{attrs:{"d":"M5.096 10.37s-1.269-3.394-2.15-5.215A1.572 1.572 0 015.36 3.187c1.178 1.18 4.338 7.12 4.662 7.444","stroke":"currentColor","stroke-width":"1.324","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    